export const LogoStandaloneIcon = ({
  variant = "savvy-900",
  color = "",
  accentColor = "",
  size = 165,
}) => {
  const LOGO_STANDALONE_VARIANTS = {
    "savvy-white": "var(--clx-savvy-white)",
    "savvy-accent": "var(--clx-savvy-accent)",
    "savvy-300": "var(--clx-savvy-300)",
    "savvy-500": "var(--clx-savvy-500)",
    "savvy-700": "var(--clx-savvy-700)",
    "savvy-900": "var(--clx-savvy-900)",
    "savvy-black": "var(--clx-savvy-black)",
  };

  const mainColor =
    color || LOGO_STANDALONE_VARIANTS[variant] || "var(--clx-savvy-900)";
  const accent = accentColor || mainColor;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.3815 29.1858C37.5505 35.3973 31.785 39.9373 24.9435 39.9373C16.63 39.9373 9.89047 33.2387 9.89047 24.9757C9.89047 17.5163 15.3885 11.3498 22.5725 10.2178V1.88525C10.8465 3.07725 1.66797 12.9513 1.66797 24.9153C1.66797 37.6803 12.117 48.0658 24.96 48.0658C36.3355 48.0658 45.8255 39.9168 47.8485 29.1858H39.3815Z"
        fill={mainColor}
      />
      <path
        d="M27.2536 24.225L26.5811 23.5565L41.2401 8.98645L41.9126 9.65495L27.2536 24.225Z"
        fill={accent}
      />
      <path
        d="M27.2233 19.442L26.5508 18.7735L38.7383 6.66L39.4108 7.3285L27.2233 19.442Z"
        fill={accent}
      />
      <path
        d="M27.2409 14.6115L26.5684 13.943L35.9309 4.637L36.6039 5.3055L27.2409 14.6115Z"
        fill={accent}
      />
      <path
        d="M27.1188 9.92L26.4463 9.2515L32.6838 3.0515L33.3563 3.7205L27.1188 9.92Z"
        fill={accent}
      />
      <path
        d="M27.2194 5.0073L26.5469 4.3388L28.9289 1.9708L29.6019 2.6393L27.2194 5.0073Z"
        fill={accent}
      />
      <path
        d="M31.1964 25.1194L30.5239 24.4509L43.3524 11.6994L44.0249 12.3684L31.1964 25.1194Z"
        fill={accent}
      />
      <path
        d="M35.9406 25.2173L35.2681 24.5488L45.1166 14.7593L45.7896 15.4278L35.9406 25.2173Z"
        fill={accent}
      />
      <path
        d="M40.86 25.1407L40.1875 24.4722L46.4015 18.2952L47.0745 18.9637L40.86 25.1407Z"
        fill={accent}
      />
      <path
        d="M45.6637 25.179L44.9912 24.5105L47.1747 22.34L47.8472 23.0085L45.6637 25.179Z"
        fill={accent}
      />
    </svg>
  );
};

export const LogoWithText = ({
  variant = "savvy-900",
  textColor = "",
  symbolColor = "",
  symbolAccent = "",
  width = 311,
}) => {
  const LOGO_WITH_TEXT_VARIANTS = {
    "savvy-900": {
      textColor: "var(--clx-savvy-900)",
      symbolColor: "var(--clx-savvy-900)",
      symbolAccent: "var(--clx-savvy-accent)",
    },
    "savvy-white": {
      textColor: "var(--clx-savvy-white)",
      symbolColor: "var(--clx-savvy-white)",
      symbolAccent: "var(--clx-savvy-white)",
    },
    "savvy-dark-gradient": {
      textColor: "var(--clx-savvy-500)",
      symbolColor: "var(--clx-savvy-500)",
      symbolAccent: "var(--clx-savvy-accent)",
    },
  };

  const defaultColors =
    LOGO_WITH_TEXT_VARIANTS[variant] ?? LOGO_WITH_TEXT_VARIANTS["savvy-900"];

  const text = textColor || defaultColors.textColor;
  const symColor = symbolColor || defaultColors.symbolColor;
  const accColor = symbolAccent || defaultColors.symbolAccent;

  return (
    <svg
      width={width}
      height={(width * 27) / 162}
      viewBox="0 0 162 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.6485 6.91696H38.3345V21.9912H34.7867V20.2739C33.8652 21.6095 32.3447 22.3251 30.5478 22.3251C26.8618 22.3251 24.8345 19.6537 24.8345 16.3622V6.91696H28.5205V15.7898C28.5205 17.5071 29.5802 18.9859 31.5614 18.9859C33.5427 18.9859 34.6485 17.4117 34.6485 15.4558V6.86926V6.91696ZM42.0666 21.9912H45.7526V0.28622H42.0666V21.9912ZM54.6911 2.05124L51.0512 3.38693V6.91696H48.2406V10.1131H51.0051V16.6484C51.0051 20.2261 52.9403 21.9435 56.3959 21.9435H58.93V18.6519H57.1331C55.4283 18.6519 54.6451 17.841 54.6451 15.9329V10.0654H58.93V6.86926H54.6451V2.00353L54.6911 2.05124ZM71.6468 15.5035C71.6468 17.5071 70.587 19.0336 68.5597 19.0336C66.5324 19.0336 65.5188 17.5071 65.5188 15.8375V6.96467H61.8328V16.4099C61.8328 19.7014 63.8601 22.3728 67.5461 22.3728C71.2321 22.3728 70.8174 21.7049 71.785 20.3216V22.0389H75.3328V6.96467H71.6468V15.5512V15.5035ZM82.843 8.9682V6.91696H79.2492V21.9912H82.9352V13.9293C82.9352 11.5442 84.3635 10.1131 86.7594 10.1131H88.1416V6.91696H86.8515C85.0546 6.91696 83.7184 7.58481 82.8891 8.9682H82.843ZM90.6297 21.9912H94.3157V0.28622H90.6297V21.9912ZM118.92 2.05124L115.28 3.38693V6.91696H108.415L104.452 16.6484L100.49 6.91696H96.5734L102.425 20.894L99.8447 27H103.669L110.718 10.1131H115.234V16.6484C115.234 20.2261 117.169 21.9435 120.625 21.9435H123.159V18.6519H121.362C119.657 18.6519 118.874 17.841 118.874 15.9329V10.0654H123.159V6.86926H118.874V2.00353H118.92V2.05124ZM128.135 0C126.845 0 125.877 0.954065 125.877 2.19435C125.877 3.43463 126.799 4.38869 128.135 4.38869C129.471 4.38869 130.346 3.43463 130.346 2.19435C130.346 0.954065 129.425 0 128.135 0ZM126.292 21.9912H129.978V6.91696H126.292V21.9912ZM140.667 18.9859C138.317 18.9859 136.705 17.0777 136.705 14.4541C136.705 11.8304 138.363 9.96996 140.667 9.96996C142.971 9.96996 143.201 10.6855 143.892 11.9258L146.841 10.3993C145.92 8.20495 143.616 6.58304 140.621 6.58304C136.29 6.58304 133.065 9.92226 133.065 14.4541C133.065 18.9859 136.29 22.3728 140.621 22.3728C144.952 22.3728 146.104 20.6555 147.118 18.2703L144.077 16.8869C143.386 18.1749 142.188 18.9382 140.667 18.9382V18.9859ZM156.425 13.023C153.66 12.5459 152.969 12.1166 152.969 11.1148C152.969 10.1131 153.845 9.39753 155.549 9.39753C157.254 9.39753 158.176 10.1608 158.729 11.2102L161.585 9.77915C160.664 7.91873 158.544 6.58304 155.503 6.58304C152.462 6.58304 149.514 8.63428 149.514 11.258C149.514 13.8816 151.218 15.2173 154.997 15.7898C157.807 16.2191 158.498 16.7915 158.498 17.841C158.498 18.8905 157.623 19.606 155.826 19.606C154.029 19.606 152.739 18.9382 152.002 17.5548L149.053 18.9859C150.205 21.1802 152.739 22.4205 155.826 22.4205C158.913 22.4205 162 20.4647 162 17.6979C162 14.9311 160.526 13.6908 156.471 13.0707H156.425V13.023Z"
        fill={text}
      />
      <path
        d="M11.9795 11.1148L18.8447 4.00707L18.5222 3.67315L11.657 10.7809L11.9795 11.1148ZM11.9795 8.77738L17.6468 2.9099L17.3242 2.57597L11.657 8.44346L11.9795 8.77738ZM11.9795 6.43993L16.3567 1.90813L16.0341 1.5742L11.657 6.10601L11.9795 6.43993ZM14.8362 1.14488L14.5137 0.810954L11.6109 3.81625L11.9334 4.15018L14.8362 1.14488ZM13.0853 0.620141L12.7628 0.28622L11.657 1.4311L11.9795 1.76502L13.0853 0.620141ZM13.8225 11.5442L19.8123 5.34276L19.4898 5.00883L13.5 11.2102L13.8225 11.5442ZM16.0341 11.5919L20.6416 6.82155L20.3191 6.48763L15.7116 11.258L16.0341 11.5919ZM18.3379 11.5442L21.2406 8.53887L20.9181 8.20495L18.0154 11.2102L18.3379 11.5442ZM20.5956 11.5919L21.6092 10.5424L21.2867 10.2085L20.273 11.258L20.5956 11.5919Z"
        fill={accColor}
      />
      <path
        d="M10.9198 18.7473C7.04949 18.7473 3.87031 15.5035 3.87031 11.4488C3.87031 7.39399 6.45051 4.81802 9.76792 4.29329V0.238516C4.28498 0.810954 0 5.62898 0 11.4488C0 17.2686 4.88396 22.7067 10.8737 22.7067C16.8635 22.7067 20.5956 18.7473 21.5631 13.5477H17.6007C16.7253 16.553 14.0529 18.7951 10.8737 18.7951L10.9198 18.7473Z"
        fill={symColor}
      />
    </svg>
  );
};

export const StrategyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <g clipPath="url(#clip0_2158_6629)">
      <path
        d="M30.0869 34.9023L41.1589 23.8303L48.0979 30.7693L64.0439 14.8233"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M64.0437 21.2305V14.8225H57.6357"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M64.0439 31.0405V45.8955"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M57.2529 35.5125V45.8965"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M50.4609 37.2215V45.8965"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M43.6699 34.2915V45.8965"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M36.8789 38.7635V45.8965"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M30.0869 39.8995V45.8965"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <mask
        id="mask0_2158_6629"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path
          d="M98.5 98.5V1.5H1.5V98.5H98.5Z"
          fill="white"
          stroke="white"
          strokeWidth="3"
        />
      </mask>
      <g mask="url(#mask0_2158_6629)">
        <path
          d="M84.0098 56.2389L84.2298 62.4939L90.4848 62.7139L96.6748 56.5249L90.7748 55.9489L90.1988 50.0499L84.0098 56.2389Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M92.1535 64.8014C93.2345 67.2284 93.8185 69.9044 93.8185 72.7394C93.8185 83.6894 84.9425 92.5664 73.9925 92.5664C63.0425 92.5664 54.1475 83.6894 54.1475 72.7394C54.1475 61.7714 63.0425 52.8944 73.9925 52.8944C76.8095 52.8944 79.5025 53.4794 81.9305 54.5604"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M80.7959 62.1819C78.8389 60.9129 76.4979 60.1719 73.9859 60.1719C67.0559 60.1719 61.4229 65.7919 61.4229 72.7349C61.4229 79.6769 67.0559 85.2969 73.9859 85.2969C80.9279 85.2969 86.5479 79.6769 86.5479 72.7349C86.5479 70.2219 85.8079 67.8809 84.5379 65.9239"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M75.3613 67.6304C74.9253 67.5114 74.4623 67.4454 73.9863 67.4454C71.0633 67.4454 68.6963 69.8124 68.6963 72.7344C68.6963 75.6574 71.0633 78.0244 73.9863 78.0244C76.9083 78.0244 79.2753 75.6574 79.2753 72.7344C79.2753 72.2584 79.2093 71.8094 79.0903 71.3724"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M73.9863 72.7344L84.2303 62.4934"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M15.8916 50.3768L17.8156 52.3008"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M9.81543 64.6543H12.5364"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M50.3596 65.0439H47.6396"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M44.5607 50.6531L42.6367 52.5771"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M26.5303 66.1334C27.9603 67.8514 29.3683 69.7364 30.1553 72.3564C30.9383 69.7674 32.3213 67.8204 33.7263 66.0314"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M35.9695 76.9951C35.9695 74.0311 36.9805 72.3581 38.8125 70.0281C40.2895 68.1491 41.1725 65.7821 41.1725 63.2051C41.1725 56.6661 35.5115 51.4501 28.8235 52.1911C23.7295 52.7541 19.6005 56.9141 19.0665 62.0111C18.7365 65.1621 19.7315 68.0741 21.5595 70.2711C23.4495 72.5411 24.3265 74.0411 24.3265 76.9951"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M24.7168 81.7402H35.4588"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M27.5137 86.9551H32.6627"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M30.1553 71.4389V75.0039"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M57.2532 94.1934H3.32617V24.7314L23.8642 4.19336H75.3812V45.8964"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M3.32617 24.7314H23.8642V4.19345"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2158_6629">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StagilityIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <g clipPath="url(#clip0_2158_6630)">
      <mask
        id="mask0_2158_6630"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path
          d="M98.5 98.5V1.5H1.5V98.5H98.5Z"
          fill="white"
          stroke="white"
          strokeWidth="3"
        />
      </mask>
      <g mask="url(#mask0_2158_6630)">
        <path
          d="M4.75 42.0186L51.304 42.0086"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M67.9365 42.0078L94.5695 41.9978"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M83.4209 33.6143L94.7499 41.6483L83.9679 50.4023"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M39.951 21.8106L37.051 35.3936L24.748 28.9506"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <mask
        id="mask1_2158_6630"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path
          d="M98.5 98.5V1.5H1.5V98.5H98.5Z"
          fill="white"
          stroke="white"
          strokeWidth="3"
        />
      </mask>
      <g mask="url(#mask1_2158_6630)">
        <path
          d="M37.0384 34.7568C34.9064 31.8388 33.6484 28.2418 33.6484 24.3518C33.6484 14.6008 41.5534 6.69581 51.3044 6.69581C61.0564 6.69581 68.9614 14.6008 68.9614 24.3518C68.9614 34.1028 61.0564 42.0078 51.3044 42.0078"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
      <mask
        id="mask2_2158_6630"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path
          d="M98.5 98.5V1.5H1.5V98.5H98.5Z"
          fill="white"
          stroke="white"
          strokeWidth="3"
        />
      </mask>
      <g mask="url(#mask2_2158_6630)">
        <path
          d="M41.4108 78.3405C38.0158 81.7355 32.5128 81.7355 29.1178 78.3405C25.7238 74.9455 25.7238 69.4425 29.1178 66.0475C32.5128 62.6535 38.0158 62.6535 41.4108 66.0475C44.8058 69.4425 44.8058 74.9455 41.4108 78.3405Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
      <mask
        id="mask3_2158_6630"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path
          d="M98.5 98.5V1.5H1.5V98.5H98.5Z"
          fill="white"
          stroke="white"
          strokeWidth="3"
        />
      </mask>
      <g mask="url(#mask3_2158_6630)">
        <path
          d="M51.9473 83.6087L50.5823 82.2437C50.1813 81.8427 50.1203 81.2307 50.3983 80.7367C51.0963 79.4997 51.6293 78.1957 52.0003 76.8557C52.1513 76.3087 52.6293 75.9197 53.1963 75.9197H55.1323C55.8183 75.9197 56.3743 75.3637 56.3743 74.6777V69.7107C56.3743 69.0247 55.8183 68.4687 55.1323 68.4687H53.1963C52.6293 68.4687 52.1513 68.0797 52.0003 67.5327C51.6293 66.1927 51.0963 64.8887 50.3983 63.6517C50.1203 63.1577 50.1813 62.5457 50.5823 62.1447L51.9473 60.7797C52.4323 60.2947 52.4323 59.5087 51.9473 59.0237L48.4353 55.5107C47.9503 55.0267 47.1643 55.0267 46.6793 55.5107L45.3133 56.8767C44.9133 57.2767 44.3003 57.3387 43.8073 57.0597C42.5703 56.3617 41.2663 55.8297 39.9263 55.4587C39.3793 55.3067 38.9893 54.8297 38.9893 54.2617V52.3257C38.9893 51.6407 38.4333 51.0847 37.7483 51.0847H32.7813C32.0953 51.0847 31.5393 51.6407 31.5393 52.3257V54.2617C31.5393 54.8297 31.1493 55.3067 30.6023 55.4587C29.2623 55.8297 27.9583 56.3617 26.7213 57.0597C26.2283 57.3387 25.6153 57.2767 25.2153 56.8767L23.8493 55.5107C23.3653 55.0267 22.5783 55.0267 22.0933 55.5107L18.5813 59.0237C18.0963 59.5087 18.0963 60.2947 18.5813 60.7797L19.9463 62.1447C20.3473 62.5457 20.4093 63.1577 20.1303 63.6517C19.4323 64.8887 18.8993 66.1927 18.5283 67.5327C18.3773 68.0797 17.8993 68.4687 17.3323 68.4687H15.3963C14.7103 68.4687 14.1543 69.0247 14.1543 69.7107V74.6777C14.1543 75.3637 14.7103 75.9197 15.3963 75.9197H17.3323C17.8993 75.9197 18.3773 76.3087 18.5283 76.8557C18.8993 78.1957 19.4323 79.4997 20.1303 80.7367C20.4093 81.2307 20.3473 81.8427 19.9463 82.2437L18.5813 83.6087C18.0963 84.0937 18.0963 84.8797 18.5813 85.3647L22.0933 88.8767C22.5783 89.3617 23.3653 89.3617 23.8493 88.8767L25.2153 87.5117C25.6153 87.1107 26.2283 87.0497 26.7213 87.3277C27.9583 88.0257 29.2623 88.5587 30.6023 88.9297C31.1493 89.0807 31.5393 89.5587 31.5393 90.1267V92.0617C31.5393 92.7477 32.0953 93.3037 32.7813 93.3037H37.7483C38.4333 93.3037 38.9893 92.7477 38.9893 92.0617V90.1267C38.9893 89.5587 39.3793 89.0807 39.9263 88.9297C41.2663 88.5587 42.5703 88.0267 43.8073 87.3277C44.3003 87.0497 44.9133 87.1107 45.3133 87.5117L46.6793 88.8767C47.1643 89.3617 47.9503 89.3617 48.4353 88.8767L51.9473 85.3647C52.4323 84.8797 52.4323 84.0937 51.9473 83.6087Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
      <mask
        id="mask4_2158_6630"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path
          d="M98.5 98.5V1.5H1.5V98.5H98.5Z"
          fill="white"
          stroke="white"
          strokeWidth="3"
        />
      </mask>
      <g mask="url(#mask4_2158_6630)">
        <path
          d="M56.1924 87.9947C57.0114 88.3647 57.8444 88.6927 58.7004 88.9297C59.2474 89.0807 59.6374 89.5587 59.6374 90.1267V92.0617C59.6374 92.7477 60.1934 93.3037 60.8784 93.3037H65.8454C66.5314 93.3037 67.0874 92.7477 67.0874 92.0617V90.1267C67.0874 89.5587 67.4764 89.0817 68.0234 88.9297C69.3644 88.5587 70.6684 88.0267 71.9044 87.3287C72.3984 87.0497 73.0104 87.1107 73.4114 87.5117L74.7764 88.8767C75.2614 89.3617 76.0484 89.3617 76.5334 88.8767L80.0454 85.3647C80.5304 84.8797 80.5304 84.0937 80.0454 83.6087L78.6794 82.2437C78.2794 81.8427 78.2174 81.2307 78.4964 80.7367C79.1944 79.4997 79.7274 78.1957 80.0974 76.8557C80.2494 76.3087 80.7264 75.9197 81.2944 75.9197H83.2304C83.9164 75.9197 84.4724 75.3637 84.4724 74.6777V69.7107C84.4724 69.0247 83.9164 68.4687 83.2304 68.4687H81.2944C80.7264 68.4687 80.2494 68.0797 80.0974 67.5327C79.7274 66.1917 79.1944 64.8887 78.4964 63.6517C78.2174 63.1577 78.2794 62.5457 78.6794 62.1447L80.0454 60.7797C80.5304 60.2947 80.5304 59.5077 80.0454 59.0237L76.5334 55.5107C76.0484 55.0267 75.2614 55.0257 74.7764 55.5107L73.4114 56.8767C73.0104 57.2767 72.3984 57.3387 71.9044 57.0597C70.6684 56.3617 69.3644 55.8297 68.0234 55.4587C67.4774 55.3067 67.0874 54.8297 67.0874 54.2617V52.3257C67.0874 51.6407 66.5314 51.0847 65.8454 51.0837L60.8784 51.0847C60.1924 51.0847 59.6374 51.6407 59.6374 52.3257V54.2617C59.6374 54.8297 59.2474 55.3067 58.7004 55.4587C57.8444 55.6957 57.0114 56.0227 56.1924 56.3937"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
      <mask
        id="mask5_2158_6630"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path
          d="M98.5 98.5V1.5H1.5V98.5H98.5Z"
          fill="white"
          stroke="white"
          strokeWidth="3"
        />
      </mask>
      <g mask="url(#mask5_2158_6630)">
        <path
          d="M58.8691 79.6261C62.2121 81.6501 66.6211 81.2281 69.5081 78.3411C72.9021 74.9461 72.9021 69.4421 69.5081 66.0481C66.6211 63.1611 62.2121 62.7391 58.8691 64.7631"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2158_6630">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CustomerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <g clipPath="url(#clip0_2158_6631)">
      <mask
        id="mask0_2158_6631"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path d="M0 0H100V100H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2158_6631)">
        <path
          d="M89.1824 49.9996C89.1824 71.6396 71.6404 89.1816 50.0004 89.1816C28.3604 89.1816 10.8184 71.6396 10.8184 49.9996C10.8184 28.3596 28.3604 10.8176 50.0004 10.8176C71.6404 10.8176 89.1824 28.3596 89.1824 49.9996Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M83.3643 50H95.0003"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M5 50H16.636"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M50 83.364V95"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M50 4.99974V16.6357"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M45.3848 62.0208C45.3848 65.8928 54.6148 65.8928 54.6148 62.0208"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M54.2855 58.054C51.4045 59.97 49.1175 60.069 45.9785 58.054"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M65.4129 75.0615V70.5885C65.4129 67.0335 62.9809 63.9465 59.5219 63.1165C58.2319 62.8075 56.7959 62.4575 55.2829 62.0805C54.4049 61.8615 53.6929 61.2265 53.3919 60.3785C53.3679 60.3105 53.3439 60.2425 53.3199 60.1735C53.0749 59.4765 53.1719 58.7135 53.8189 58.3485C55.1519 57.5975 56.2059 56.3005 56.8319 54.2775C57.1369 53.2765 57.3819 48.2795 56.3759 46.3415C53.7759 41.3345 43.2169 41.6495 43.2169 50.0025C43.2169 50.7725 43.1289 53.2765 43.4339 54.2775C44.0519 56.2915 45.0979 57.5815 46.4219 58.3345C47.0719 58.7035 46.9069 59.4745 46.6519 60.1715C46.6199 60.2585 46.5879 60.3445 46.5559 60.4295C46.2469 61.2575 45.5469 61.8765 44.6849 62.0915C43.1839 62.4665 41.7599 62.8135 40.4799 63.1205C37.0209 63.9505 34.5869 67.0375 34.5869 70.5925V75.0615"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M58.8779 41.2463C58.8779 44.1953 65.9079 44.1953 65.9079 41.2463"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M65.6581 38.2247C63.4631 39.6837 61.7211 39.7597 59.3311 38.2247"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M74.1325 57.291V47.771C74.1325 45.064 72.2805 42.713 69.6465 42.081C68.6635 41.845 67.5695 41.578 66.4175 41.291C65.7485 41.125 65.2065 40.641 64.9775 39.995C64.9585 39.943 64.9405 39.891 64.9225 39.839C64.7355 39.308 64.8095 38.727 65.3025 38.449C66.3175 37.877 67.1205 36.889 67.5965 35.349C67.8295 34.586 68.0155 30.78 67.2495 29.304C65.2695 25.49 57.2275 25.731 57.2275 32.092C57.2275 32.679 57.1605 34.586 57.3925 35.349C57.8635 36.882 58.6605 37.865 59.6685 38.438C60.1635 38.719 60.0375 39.306 59.8435 39.837C59.8195 39.903 59.7945 39.969 59.7705 40.034C59.5355 40.665 59.0025 41.136 58.3455 41.3C57.2025 41.586 56.1175 41.85 55.1425 42.084C54.2475 42.298 53.4425 42.712 52.7695 43.27"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M68.6523 57.291V47.771"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M41.1218 41.2463C41.1218 44.1953 34.0918 44.1953 34.0918 41.2463"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M34.3428 38.2247C36.5378 39.6837 38.2788 39.7597 40.6698 38.2247"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M25.8682 57.291V47.771C25.8682 45.064 27.7202 42.713 30.3542 42.081C31.3372 41.845 32.4312 41.578 33.5832 41.291C34.2522 41.125 34.7942 40.641 35.0232 39.995C35.0412 39.943 35.0602 39.891 35.0782 39.839C35.2652 39.308 35.1912 38.727 34.6982 38.449C33.6832 37.877 32.8802 36.889 32.4032 35.349C32.1712 34.586 31.9852 30.78 32.7512 29.304C34.7312 25.49 42.7732 25.731 42.7732 32.092C42.7732 32.679 42.8402 34.586 42.6082 35.349C42.1372 36.882 41.3402 37.865 40.3322 38.438C39.8372 38.719 39.9622 39.306 40.1572 39.837C40.1812 39.903 40.2062 39.969 40.2302 40.034C40.4652 40.665 40.9982 41.136 41.6552 41.3C42.7982 41.586 43.8832 41.85 44.8572 42.084C45.7532 42.298 46.5582 42.712 47.2312 43.27"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M31.3477 57.291V47.771"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M39.8662 70.5925V75.0615"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M60.1338 75.0615V70.5885"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2158_6631">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PsychSafetyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <g clipPath="url(#clip0_2158_6632)">
      <mask
        id="mask0_2158_6632"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path d="M0 0H100V100H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2158_6632)">
        <path
          d="M16.3167 48.6115V37.9015C16.3327 34.7845 13.7907 32.2425 10.6737 32.2265L8.86766 32.2425C7.62066 32.2425 6.61366 33.2495 6.59766 34.5125V63.3495C6.59766 65.1405 7.31666 66.8825 8.59566 68.1615L21.2877 80.8535C22.6787 82.2445 23.5577 84.0185 23.8137 85.9365"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M43.2033 85.9521L43.2193 78.7751C43.2193 74.4911 41.2053 70.4621 37.7523 67.9051L35.0833 65.9071C32.3973 63.8931 29.8393 61.6871 27.4583 59.3051L22.9183 54.7651C22.2313 54.0781 21.3993 53.5981 20.5363 53.3421C18.6023 52.7831 16.4443 53.2461 14.9253 54.7651L14.8613 54.8291C13.4553 56.2361 13.4393 58.5221 14.8613 59.9441L26.0193 71.1021"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M47.4881 95V85.952H43.2041H23.8301L23.8141 85.936H19.9141V94.984"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M83.6835 48.6115V37.9015C83.6675 34.7845 86.2095 32.2425 89.3265 32.2265L91.1325 32.2425C92.3795 32.2425 93.3865 33.2495 93.4025 34.5125V63.3495C93.4025 65.1405 92.6835 66.8825 91.4045 68.1615L78.7125 80.8535C77.3215 82.2445 76.4425 84.0185 76.1865 85.9365"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M56.7973 85.9521L56.7812 78.7751C56.7812 74.4911 58.7952 70.4621 62.2483 67.9051L64.9172 65.9071C67.6032 63.8931 70.1612 61.6871 72.5422 59.3051L77.0823 54.7651C77.7693 54.0781 78.6013 53.5981 79.4643 53.3421C81.3983 52.7831 83.5563 53.2461 85.0753 54.7651L85.1392 54.8291C86.5452 56.2361 86.5612 58.5221 85.1392 59.9441L73.9813 71.1021"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M52.5127 95V85.952H56.7967H76.1707L76.1867 85.936H80.0867V94.984"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M55.0828 12.8584L48.8118 19.4424L45.6768 16.1504"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M56.4349 5.00041C56.4349 7.53341 58.5149 9.59641 61.0679 9.59641C61.0679 9.59641 62.9049 24.1154 49.9999 29.1914C37.0949 24.1154 38.9309 9.59641 38.9309 9.59641C41.4849 9.59641 43.5649 7.53341 43.5649 5.00041H56.4349Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M23.5957 50.5391L23.5987 47.7801C23.6077 44.6841 25.2257 41.7331 27.9727 40.3051C29.3827 39.5721 31.0047 39.1601 32.7727 39.1601C34.5487 39.1601 36.1707 39.5711 37.5797 40.3011C40.3267 41.7251 41.9427 44.6761 41.9527 47.7711V50.5391"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M32.7657 33.7549C30.4857 33.7549 28.6387 31.9069 28.6387 29.6279V27.8059C28.6387 25.5259 30.4857 23.6779 32.7657 23.6779C35.0457 23.6779 36.8927 25.5259 36.8927 27.8059V29.6279C36.8927 31.9069 35.0457 33.7549 32.7657 33.7549Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M58.0469 50.5391L58.0499 47.7801C58.0589 44.6841 59.6769 41.7331 62.4239 40.3051C63.8339 39.5721 65.4559 39.1601 67.2239 39.1601C68.9999 39.1601 70.6229 39.5711 72.0309 40.3011C74.7779 41.7251 76.3939 44.6761 76.4039 47.7711V50.5391"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M67.2169 33.7549C64.9369 33.7549 63.0889 31.9069 63.0889 29.6279V27.8059C63.0889 25.5259 64.9369 23.6779 67.2169 23.6779C69.4959 23.6779 71.3439 25.5259 71.3439 27.8059V29.6279C71.3439 31.9069 69.4959 33.7549 67.2169 33.7549Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M40.8232 63.8418L40.8262 61.0828C40.8352 57.9868 42.4532 55.0358 45.2002 53.6078C46.6102 52.8748 48.2322 52.4628 50.0002 52.4628C51.7762 52.4628 53.3992 52.8738 54.8072 53.6038C57.5542 55.0278 59.1702 57.9788 59.1802 61.0738V63.8418"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M49.9922 47.0576C47.7122 47.0576 45.8652 45.2096 45.8652 42.9306V41.1086C45.8652 38.8286 47.7122 36.9806 49.9922 36.9806C52.2722 36.9806 54.1192 38.8286 54.1192 41.1086V42.9306C54.1192 45.2096 52.2722 47.0576 49.9922 47.0576Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2158_6632">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ConflictIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <g clipPath="url(#clip0_2158_6633)">
      <mask
        id="mask0_2158_6633"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path d="M0 0H100V100H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2158_6633)">
        <path
          d="M16.7442 21.8168H17.4752C20.9512 21.8168 23.6512 24.8478 23.2502 28.3008L22.8842 31.4488C22.5442 34.3798 20.0612 36.5918 17.1092 36.5918C14.1582 36.5918 11.6752 34.3798 11.3352 31.4488L10.9692 28.3008C10.5682 24.8478 13.2672 21.8168 16.7442 21.8168Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M9.69727 95V67.94"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M24.5215 67.94V95"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M9.69712 52.4194V67.9404H7.56612C5.11112 67.9404 3.12012 64.8484 3.12012 62.6084V49.4024C3.12012 45.9014 5.98412 42.8364 10.1041 41.9294C15.6611 40.7054 18.5621 40.7054 24.1191 41.9294C28.2391 42.8364 31.1031 45.9014 31.1031 49.4024V62.6084C31.1031 64.8484 29.1121 67.9404 26.6571 67.9404H24.5221V52.4194"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M17.1094 95V67.94"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M82.5196 21.8168H83.2506C86.7276 21.8168 89.4266 24.8478 89.0256 28.3008L88.6596 31.4488C88.3196 34.3798 85.8366 36.5918 82.8856 36.5918C79.9336 36.5918 77.4506 34.3798 77.1106 31.4488L76.7446 28.3008C76.3436 24.8478 79.0436 21.8168 82.5196 21.8168Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M75.4727 95V67.94"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M90.2979 67.94V95"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M75.4735 52.4194V67.9404H73.3425C70.8875 67.9404 68.8975 64.8484 68.8975 62.6084V49.4024C68.8975 45.9014 71.7605 42.8364 75.8805 41.9294C81.4375 40.7054 84.3385 40.7054 89.8955 41.9294C94.0155 42.8364 96.8795 45.9014 96.8795 49.4024V62.6084C96.8795 64.8484 94.8895 67.9404 92.4335 67.9404H90.2985V52.4194"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M82.8857 95V67.94"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M3.12012 95H96.8791"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M45.9961 20.3115V28.5585H56.5151L64.2771 34.3105V28.5585H69.4101V15.6985H55.3511"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M25.9111 5.00045V20.3125H31.7511V26.0645L39.5141 20.3125H55.3511V5.00045H25.9111Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M44.6509 84.933L61.9749 58.557C61.9779 58.553 61.9749 58.548 61.9709 58.548H51.7559C51.7529 58.548 51.7499 58.545 51.7509 58.542L53.6959 41.52C53.6969 41.514 53.6879 41.512 53.6849 41.517L38.1129 66.335C38.1109 66.339 38.1139 66.343 38.1179 66.343H47.6499C47.6539 66.343 47.6569 66.347 47.6559 66.35L44.6409 84.929C44.6399 84.935 44.6469 84.938 44.6509 84.933Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2158_6633">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CollaborationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <g clipPath="url(#clip0_2158_6634)">
      <path
        d="M88.3105 46.0547L94.6055 41.2677"
        stroke="#5900DC"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <mask
        id="mask0_2158_6634"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path d="M0 0H100V100H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2158_6634)">
        <path
          d="M63.5347 17.7178H49.9127C47.6207 17.7178 45.7627 15.8598 45.7627 13.5678C45.7627 11.2758 47.6207 9.41677 49.9127 9.41677H69.1597H79.4707C81.9427 9.41677 84.3837 9.95577 86.6257 10.9958C88.8677 12.0358 91.3097 12.5748 93.7807 12.5748H94.6067"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M58.5943 26.0176H42.1383C39.8463 26.0176 37.9883 24.1596 37.9883 21.8676C37.9883 19.5756 39.8463 17.7176 42.1383 17.7176H58.5943"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M51.6958 34.3184H38.0738C35.7818 34.3184 33.9238 32.4604 33.9238 30.1684C33.9238 27.8764 35.7818 26.0174 38.0738 26.0174H57.3208"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M57.2183 42.6191H43.6383C41.3463 42.6191 39.4883 40.7611 39.4883 38.4691C39.4883 36.1771 41.3463 34.3191 43.6383 34.3191H51.5933"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M54.1768 88.705L58.9638 95.001"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M82.6777 63.929V50.307C82.6777 48.015 84.5357 46.157 86.8277 46.157C89.1197 46.157 90.9777 48.015 90.9777 50.307V69.554V79.865C90.9777 82.337 90.4397 84.778 89.3997 87.02C88.3597 89.262 87.8207 91.704 87.8207 94.175V95.001"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M74.377 58.9883V42.5323C74.377 40.2403 76.235 38.3823 78.527 38.3823C80.819 38.3823 82.678 40.2403 82.678 42.5323V58.9883"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M66.0771 52.0908V38.4688C66.0771 36.1768 67.9351 34.3188 70.2271 34.3188C72.5191 34.3188 74.3771 36.1768 74.3771 38.4688V57.7158"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M57.7764 57.6123V44.0323C57.7764 41.7413 59.6344 39.8823 61.9264 39.8823C64.2184 39.8823 66.0764 41.7413 66.0764 44.0323V51.9873"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M11.6905 53.7823L5.39551 58.5693"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M36.4665 82.283H50.0885C52.3805 82.283 54.2385 84.141 54.2385 86.433C54.2385 88.725 52.3805 90.583 50.0885 90.583H30.8415H20.5305C18.0585 90.583 15.6175 90.044 13.3755 89.004C11.1335 87.964 8.69153 87.426 6.22053 87.426H5.39453"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M41.4072 73.9822H57.8632C60.1552 73.9822 62.0132 75.8402 62.0132 78.1322C62.0132 80.4242 60.1552 82.2832 57.8632 82.2832H41.4072"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M48.3047 65.6824H61.9267C64.2187 65.6824 66.0767 67.5404 66.0767 69.8324C66.0767 72.1244 64.2187 73.9824 61.9267 73.9824H42.6797"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M42.7832 57.3816H56.3632C58.6542 57.3816 60.5132 59.2396 60.5132 61.5316C60.5132 63.8236 58.6542 65.6826 56.3632 65.6826H48.4082"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M45.7626 11.2959L40.9756 5.0009"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M17.424 36.0718V49.6938C17.424 51.9858 15.566 53.8438 13.274 53.8438C10.982 53.8438 9.12305 51.9858 9.12305 49.6938V30.4468V20.1357C9.12305 17.6637 9.66205 15.2228 10.702 12.9808C11.742 10.7388 12.281 8.29675 12.281 5.82575V4.99975"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M25.7248 41.0122V57.4682C25.7248 59.7602 23.8668 61.6182 21.5748 61.6182C19.2828 61.6182 17.4248 59.7602 17.4248 57.4682V41.0122"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M34.0246 47.9096V61.5316C34.0246 63.8236 32.1666 65.6816 29.8746 65.6816C27.5826 65.6816 25.7246 63.8236 25.7246 61.5316V47.9096"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M42.3254 42.3882V55.9682C42.3254 58.2602 40.4674 60.1182 38.1754 60.1182C35.8834 60.1182 34.0244 58.2602 34.0244 55.9682V48.0132"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2158_6634">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EdixIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <g clipPath="url(#clip0_2158_6636)">
      <mask
        id="mask0_2158_6636"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path d="M0 0H100V100H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2158_6636)">
        <path
          d="M53.7361 40.7364C53.8801 40.6894 54.0221 40.6394 54.1641 40.5884C54.2621 40.5534 54.3601 40.5194 54.4571 40.4824C54.5841 40.4344 54.7101 40.3824 54.8361 40.3304C54.9461 40.2854 55.0581 40.2404 55.1681 40.1914C55.2771 40.1434 55.3851 40.0934 55.4921 40.0424C55.6161 39.9854 55.7401 39.9274 55.8631 39.8664C55.9551 39.8194 56.0461 39.7714 56.1381 39.7234C56.2721 39.6524 56.4051 39.5824 56.5381 39.5074C56.6171 39.4624 56.6951 39.4164 56.7731 39.3704C56.8431 39.3284 56.9151 39.2884 56.9851 39.2454L60.3561 41.6754C61.0891 42.2044 62.1001 42.1124 62.7251 41.4604L64.9261 39.1674C65.5511 38.5154 65.6021 37.5014 65.0431 36.7904L62.4761 33.5234C62.5161 33.4514 62.5531 33.3784 62.5921 33.3054C62.6341 33.2254 62.6781 33.1464 62.7191 33.0654C62.7881 32.9304 62.8531 32.7934 62.9181 32.6564C62.9621 32.5634 63.0071 32.4704 63.0501 32.3764C63.1061 32.2514 63.1581 32.1254 63.2111 31.9994C63.2571 31.8894 63.3031 31.7794 63.3461 31.6684C63.3901 31.5564 63.4311 31.4434 63.4721 31.3304C63.5181 31.2024 63.5651 31.0754 63.6081 30.9464C63.6401 30.8474 63.6701 30.7484 63.7011 30.6494C63.7461 30.5054 63.7911 30.3614 63.8311 30.2154C63.8561 30.1274 63.8781 30.0384 63.9011 29.9504C63.9211 29.8714 63.9441 29.7934 63.9631 29.7134L68.0641 29.0484C68.9571 28.9034 69.6061 28.1234 69.5881 27.2204L69.5221 24.0434C69.5031 23.1394 68.8221 22.3874 67.9251 22.2794L63.7991 21.7834C63.7761 21.7044 63.7511 21.6264 63.7271 21.5484C63.7011 21.4614 63.6751 21.3744 63.6471 21.2884C63.6011 21.1444 63.5501 21.0014 63.4991 20.8594C63.4641 20.7614 63.4301 20.6644 63.3931 20.5664C63.3451 20.4394 63.2931 20.3134 63.2411 20.1874C63.1961 20.0774 63.1511 19.9664 63.1031 19.8564C63.0551 19.7464 63.0041 19.6384 62.9531 19.5304C62.8951 19.4064 62.8381 19.2834 62.7771 19.1614C62.7301 19.0684 62.6811 18.9774 62.6331 18.8854C62.5631 18.7514 62.4931 18.6184 62.4191 18.4864C62.3741 18.4064 62.3261 18.3284 62.2801 18.2494C62.2391 18.1794 62.1991 18.1084 62.1571 18.0384L64.5861 14.6684C65.1151 13.9344 65.0231 12.9244 64.3711 12.2984L62.0781 10.0984C61.4261 9.47237 60.4121 9.42237 59.7011 9.98037L56.4341 12.5474C56.3621 12.5084 56.2901 12.4714 56.2181 12.4334C56.1371 12.3904 56.0571 12.3454 55.9751 12.3044C55.8411 12.2354 55.7051 12.1704 55.5691 12.1064C55.4751 12.0614 55.3811 12.0164 55.2861 11.9744C55.1621 11.9184 55.0361 11.8654 54.9111 11.8134C54.8001 11.7674 54.6901 11.7204 54.5781 11.6774C54.4671 11.6334 54.3541 11.5934 54.2421 11.5524C54.1141 11.5064 53.9861 11.4594 53.8571 11.4164C53.7581 11.3834 53.6591 11.3534 53.5601 11.3224C53.4161 11.2774 53.2721 11.2334 53.1261 11.1924C53.0381 11.1674 52.9501 11.1464 52.8621 11.1234C52.7831 11.1024 52.7041 11.0804 52.6241 11.0614L51.9591 6.95937C51.8141 6.06737 51.0351 5.41737 50.1311 5.43637L46.9541 5.50137C46.0501 5.52037 45.2981 6.20137 45.1901 7.09937L44.6951 11.2244C44.6161 11.2474 44.5391 11.2724 44.4601 11.2964C44.3731 11.3234 44.2851 11.3484 44.1981 11.3764C44.0551 11.4234 43.9131 11.4734 43.7711 11.5244C43.6731 11.5594 43.5751 11.5934 43.4781 11.6304C43.3501 11.6794 43.2241 11.7304 43.0981 11.7824C42.9881 11.8284 42.8771 11.8734 42.7671 11.9214C42.6571 11.9694 42.5491 12.0204 42.4411 12.0714C42.3171 12.1284 42.1941 12.1854 42.0731 12.2464C41.9791 12.2934 41.8881 12.3424 41.7961 12.3904C41.6621 12.4604 41.5291 12.5314 41.3971 12.6054C41.3181 12.6504 41.2401 12.6974 41.1611 12.7434C41.0911 12.7854 41.0191 12.8244 40.9501 12.8674L37.5791 10.4374C36.8461 9.90837 35.8351 10.0004 35.2091 10.6534L33.0091 12.9464C32.3831 13.5984 32.3331 14.6114 32.8911 15.3224L35.4581 18.5904C35.4191 18.6614 35.3821 18.7344 35.3441 18.8064C35.3011 18.8864 35.2571 18.9674 35.2151 19.0484C35.1461 19.1834 35.0821 19.3184 35.0171 19.4544C34.9731 19.5494 34.9271 19.6424 34.8851 19.7374C34.8291 19.8624 34.7771 19.9874 34.7241 20.1124C34.6781 20.2234 34.6321 20.3334 34.5881 20.4454C34.5441 20.5574 34.5041 20.6694 34.4631 20.7814C34.4171 20.9094 34.3701 21.0374 34.3271 21.1674C34.2941 21.2654 34.2641 21.3654 34.2331 21.4644C34.1881 21.6084 34.1441 21.7524 34.1031 21.8974C34.0791 21.9854 34.0571 22.0744 34.0341 22.1634C34.0131 22.2424 33.9911 22.3204 33.9721 22.3994L29.8701 23.0654C28.9781 23.2094 28.3281 23.9894 28.3471 24.8934L28.4121 28.0704C28.4311 28.9744 29.1121 29.7264 30.0101 29.8334L34.1351 30.3294C34.1581 30.4074 34.1831 30.4854 34.2071 30.5634C34.2341 30.6504 34.2591 30.7384 34.2871 30.8254C34.3341 30.9694 34.3841 31.1104 34.4351 31.2524C34.4701 31.3504 34.5041 31.4494 34.5411 31.5464C34.5901 31.6734 34.6411 31.7994 34.6931 31.9254C34.7391 32.0354 34.7841 32.1464 34.8321 32.2564C34.8801 32.3664 34.9311 32.4744 34.9821 32.5834C35.0391 32.7064 35.0971 32.8294 35.1581 32.9514C35.2041 33.0444 35.2531 33.1364 35.3021 33.2284C35.3711 33.3614 35.4421 33.4944 35.5161 33.6264C35.5611 33.7064 35.6081 33.7844 35.6551 33.8634C35.6961 33.9334 35.7361 34.0044 35.7781 34.0744L33.3481 37.4454C32.8191 38.1784 32.9111 39.1884 33.5641 39.8144L35.8571 42.0154C36.5091 42.6404 37.5221 42.6904 38.2331 42.1324L41.5011 39.5654C41.5721 39.6054 41.6451 39.6414 41.7171 39.6804C41.7971 39.7234 41.8781 39.7674 41.9591 39.8094C42.0941 39.8774 42.2301 39.9424 42.3661 40.0064C42.4601 40.0514 42.5531 40.0964 42.6481 40.1394C42.7731 40.1954 42.8981 40.2474 43.0241 40.2994C43.1341 40.3454 43.2441 40.3924 43.3561 40.4364C43.4681 40.4794 43.5801 40.5194 43.6931 40.5604C43.8201 40.6074 43.9481 40.6534 44.0781 40.6974C44.1761 40.7294 44.2761 40.7604 44.3751 40.7904C44.5191 40.8354 44.6631 40.8804 44.8081 40.9204C44.8961 40.9454 44.9851 40.9674 45.0741 40.9904C45.1531 41.0104 45.2311 41.0324 45.3101 41.0524L45.9761 45.1534C46.1201 46.0464 46.9001 46.6954 47.8041 46.6774L50.9811 46.6114C51.8851 46.5924 52.6371 45.9114 52.7451 45.0144L53.2401 40.8884C53.3191 40.8654 53.3961 40.8404 53.4741 40.8164C53.5611 40.7904 53.6491 40.7644 53.7361 40.7364Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.8105 33.728C42.5735 32.537 40.1045 28.137 41.2955 23.9C42.4875 19.663 46.8875 17.194 51.1245 18.385C55.3605 19.576 57.8295 23.977 56.6385 28.213C55.4475 32.45 51.0475 34.919 46.8105 33.728Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.9668 52.4875V64.2705"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M94.4496 80.6365C94.4496 86.0485 90.0626 90.4365 84.6496 90.4365C79.2376 90.4365 74.8506 86.0485 74.8506 80.6365C74.8506 75.2245 79.2376 70.8365 84.6496 70.8365C90.0626 70.8365 94.4496 75.2245 94.4496 80.6365Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.6235 75.4265C22.5725 76.9355 23.1215 78.7225 23.1215 80.6365C23.1215 86.0485 18.7345 90.4365 13.3225 90.4365C7.91046 90.4365 3.52246 86.0485 3.52246 80.6365C3.52246 75.2245 7.91046 70.8375 13.3225 70.8375C14.9055 70.8375 16.4005 71.2125 17.7235 71.8795"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.61523 79.2204L13.6292 83.2344L25.1762 71.6864"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M57.2739 75.4265C58.2229 76.9355 58.7719 78.7225 58.7719 80.6365C58.7719 86.0485 54.3849 90.4365 48.9729 90.4365C43.5609 90.4365 39.1729 86.0485 39.1729 80.6365C39.1729 75.2245 43.5609 70.8375 48.9729 70.8375C50.5559 70.8375 52.0509 71.2125 53.3739 71.8795"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.2656 79.2204L49.2786 83.2344L60.8266 71.6864"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M92.9242 75.4265C93.8732 76.9355 94.4222 78.7225 94.4222 80.6365C94.4222 86.0485 90.0352 90.4365 84.6232 90.4365C79.2112 90.4365 74.8232 86.0485 74.8232 80.6365C74.8232 75.2245 79.2112 70.8375 84.6232 70.8375C86.2062 70.8375 87.7012 71.2125 89.0242 71.8795"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M80.916 79.2204L84.93 83.2344L96.477 71.6864"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.6602 80.8496H34.6552"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M63.3301 80.8496H70.3251"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2158_6636">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ENpsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
  >
    <g clipPath="url(#clip0_2158_6635)">
      <mask
        id="mask0_2158_6635"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <path d="M0 0H100V100H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2158_6635)">
        <path
          d="M36.5555 74.7533C31.8845 78.3623 28.8715 84.0253 28.8715 90.4023H5.77246C5.77246 74.2513 14.7065 60.1793 27.9135 52.8803L36.5555 74.7533Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.6943 74.7644L69.3473 52.8794C82.5433 60.1784 91.4773 74.2504 91.4773 90.4014H68.3903C68.3903 89.7674 68.3603 89.1414 68.3023 88.5234"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.6941 74.7646C57.3541 72.1716 53.1731 70.6426 48.6311 70.6426C44.0881 70.6426 39.8951 72.1716 36.5551 74.7526L27.9141 52.8796C34.0571 49.4816 41.1211 47.5436 48.6311 47.5436C56.1391 47.5436 63.2051 49.4816 69.3471 52.8796L60.6941 74.7646Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.7234 93.3317C48.4124 94.4877 45.6014 93.5517 44.4454 91.2407C43.2894 88.9297 44.2264 86.1187 46.5374 84.9627C48.8484 83.8067 51.6584 84.7437 52.8144 87.0547C53.9704 89.3647 53.0344 92.1757 50.7234 93.3317Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M52.8154 87.0547L69.5714 78.6737"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M67.0765 44.8164L64.1305 41.0654C64.1755 40.9834 64.2185 40.8994 64.2625 40.8164C64.3115 40.7244 64.3615 40.6334 64.4095 40.5404C64.4885 40.3854 64.5635 40.2284 64.6375 40.0714C64.6885 39.9644 64.7395 39.8574 64.7885 39.7494C64.8525 39.6054 64.9125 39.4614 64.9735 39.3164C65.0255 39.1904 65.0785 39.0644 65.1285 38.9374C65.1795 38.8084 65.2255 38.6784 65.2725 38.5494C65.3255 38.4024 65.3795 38.2564 65.4285 38.1084C65.4665 37.9944 65.5005 37.8814 65.5365 37.7674C65.5875 37.6024 65.6385 37.4364 65.6855 37.2694C65.7135 37.1684 65.7385 37.0664 65.7655 36.9654C65.7885 36.8744 65.8145 36.7844 65.8365 36.6934L70.5445 35.9294C71.5685 35.7634 72.3145 34.8684 72.2925 33.8314L72.2175 30.1844C72.1955 29.1474 71.4145 28.2844 70.3835 28.1604L65.6485 27.5914C65.6225 27.5004 65.5935 27.4114 65.5655 27.3214C65.5355 27.2214 65.5065 27.1214 65.4745 27.0234C65.4205 26.8574 65.3625 26.6944 65.3045 26.5304C65.2645 26.4184 65.2255 26.3064 65.1825 26.1944C65.1275 26.0484 65.0675 25.9044 65.0085 25.7594C64.9565 25.6324 64.9045 25.5054 64.8495 25.3794C64.7935 25.2534 64.7355 25.1294 64.6775 25.0054C64.6115 24.8634 64.5455 24.7224 64.4755 24.5824C64.4215 24.4754 64.3655 24.3704 64.3105 24.2644C64.2295 24.1114 64.1495 23.9584 64.0645 23.8074C64.0125 23.7154 63.9575 23.6254 63.9045 23.5344C63.8575 23.4544 63.8115 23.3734 63.7635 23.2934L66.5525 19.4244C67.1585 18.5824 67.0535 17.4224 66.3045 16.7044L63.6725 14.1794C62.9245 13.4604 61.7615 13.4034 60.9455 14.0444L57.1945 16.9904C57.1125 16.9454 57.0295 16.9034 56.9475 16.8594C56.8545 16.8094 56.7625 16.7584 56.6685 16.7114C56.5135 16.6324 56.3575 16.5584 56.2015 16.4844C56.0935 16.4324 55.9865 16.3814 55.8775 16.3324C55.7345 16.2674 55.5905 16.2074 55.4465 16.1474C55.3195 16.0944 55.1935 16.0414 55.0655 15.9914C54.9365 15.9414 54.8075 15.8954 54.6785 15.8484C54.5315 15.7944 54.3855 15.7414 54.2365 15.6914C54.1235 15.6544 54.0095 15.6194 53.8965 15.5844C53.7305 15.5324 53.5655 15.4814 53.3975 15.4344C53.2975 15.4064 53.1965 15.3814 53.0955 15.3554C53.0045 15.3314 52.9135 15.3064 52.8215 15.2844L52.0585 10.5764C51.8925 9.55238 50.9975 8.80638 49.9605 8.82838L46.3135 8.90339C45.2765 8.92439 44.4125 9.70638 44.2895 10.7364L43.7205 15.4714C43.6305 15.4974 43.5415 15.5264 43.4515 15.5544C43.3515 15.5844 43.2505 15.6144 43.1515 15.6464C42.9855 15.6994 42.8225 15.7584 42.6595 15.8164C42.5475 15.8564 42.4355 15.8954 42.3235 15.9374C42.1775 15.9934 42.0325 16.0524 41.8885 16.1124C41.7615 16.1644 41.6345 16.2164 41.5085 16.2714C41.3825 16.3264 41.2575 16.3854 41.1335 16.4434C40.9925 16.5094 40.8505 16.5754 40.7115 16.6454C40.6045 16.6984 40.4985 16.7544 40.3935 16.8104C40.2405 16.8904 40.0875 16.9714 39.9355 17.0564C39.8445 17.1084 39.7555 17.1624 39.6645 17.2154C39.5835 17.2624 39.5025 17.3084 39.4225 17.3574L35.5535 14.5684C34.7115 13.9614 33.5515 14.0674 32.8335 14.8154L30.3075 17.4474C29.5895 18.1964 29.5315 19.3594 30.1725 20.1754L33.1195 23.9254C33.0735 24.0084 33.0315 24.0914 32.9875 24.1734C32.9385 24.2664 32.8875 24.3584 32.8395 24.4524C32.7605 24.6064 32.6865 24.7624 32.6125 24.9184C32.5615 25.0264 32.5095 25.1344 32.4605 25.2434C32.3965 25.3854 32.3365 25.5294 32.2765 25.6734C32.2235 25.8004 32.1705 25.9274 32.1205 26.0554C32.0705 26.1834 32.0235 26.3124 31.9775 26.4414C31.9235 26.5884 31.8705 26.7354 31.8205 26.8834C31.7825 26.9974 31.7485 27.1114 31.7125 27.2254C31.6615 27.3904 31.6105 27.5554 31.5635 27.7224C31.5355 27.8234 31.5105 27.9254 31.4835 28.0264C31.4605 28.1174 31.4345 28.2074 31.4125 28.2984L26.7045 29.0624C25.6805 29.2284 24.9355 30.1234 24.9565 31.1604L25.0325 34.8074C25.0535 35.8444 25.8355 36.7074 26.8655 36.8314L31.6005 37.4004C31.6265 37.4904 31.6555 37.5784 31.6835 37.6684C31.7135 37.7694 31.7425 37.8694 31.7755 37.9694C31.8285 38.1344 31.8865 38.2974 31.9445 38.4594C31.9845 38.5724 32.0245 38.6854 32.0665 38.7974C32.1225 38.9434 32.1815 39.0874 32.2415 39.2324C32.2935 39.3584 32.3445 39.4864 32.4005 39.6124C32.4555 39.7384 32.5135 39.8624 32.5725 39.9864C32.6385 40.1284 32.7045 40.2694 32.7735 40.4094C32.8275 40.5164 32.8835 40.6214 32.9395 40.7274C33.0195 40.8804 33.1005 41.0334 33.1855 41.1844C33.2375 41.2764 33.2915 41.3654 33.3445 41.4564C33.3915 41.5374 33.4375 41.6184 33.4865 41.6984L30.6975 45.5674"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.1492 41.3009C41.2862 39.9339 38.4522 34.8829 39.8192 30.0199C41.1872 25.1569 46.2372 22.3229 51.1002 23.6909C55.9632 25.0579 58.7972 30.1079 57.4302 34.9709C56.0632 39.8339 51.0122 42.6679 46.1492 41.3009Z"
          stroke="#5900DC"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2158_6635">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
